import React, { useCallback } from 'react'
import cn from 'classnames'
import { l, Loader, BtnV2 } from '@manychat/manyui'

import { usePage } from 'common/core/coreHooks'
import { analyticsService } from 'utils/services/analytics'

import BubbleSvg from './assets/bubble.svg'

import cm from './Confirm3DS.module.css'

interface Confirm3DSPageProps {
  className?: string
  isLoading?: boolean
  onConfirm: () => void | Promise<void>
}

export const Confirm3DS = ({ className, isLoading = false, onConfirm }: Confirm3DSPageProps) => {
  usePage('Confirm payment', 'PAGE_VIEW.BILLING_NEXT_ACTIONS_REQUIRED')

  const handleContinue = useCallback(() => {
    analyticsService.sendEvent('BILLING_NEXT_ACTIONS_REQUIRED.CLICK_VERIFY')
    onConfirm()
  }, [onConfirm])

  if (isLoading) {
    return (
      <div className={cn(cm.root, className)}>
        <Loader center />
      </div>
    )
  }

  return (
    <div className={cn(cm.root, className)}>
      <img className="m-b-lg" src={BubbleSvg} />
      <span className="text-display-sm text-center m-b-sm">{l.translate('Great!')}</span>
      <span className="m-b-xl text-center text-secondary">
        {l.translate(
          'Please confirm your payment on the next step <br/> so that we can charge the subscription fee.',
        )}
      </span>
      <BtnV2 variant="primary" onClick={handleContinue} className="m-b-md">
        {l.translate('Continue')}
      </BtnV2>
    </div>
  )
}
